// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/checkIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Selected" aria-label="Selected" />;
}
